module.exports = __webpack_public_path__ + "img/Ma.Maritime.Suspendeddeck.Suspendeddeck-10m.Concrete.0f9522ce.png";